import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api } from '@/lib/api';
import toast from 'react-hot-toast';

const CATEGORIES: Record<'buyer' | 'seller', string[]> = {
  buyer: ['False "not received" claim', 'Abusive messages', 'Payment / chargeback abuse', 'Repeated false disputes', 'Asked to transact off-platform', 'Other'],
  seller: ['Rude or abusive', 'Slow / failed to dispatch', 'Item not as described', 'Asked to transact off-platform', 'Suspected counterfeit seller', 'Other'],
};

/** File a conduct complaint against the other party on an order. */
export function ComplaintModal({ orderId, against, onClose }: { orderId: string; against: 'buyer' | 'seller'; onClose: () => void }) {
  const [category, setCategory] = useState(CATEGORIES[against][0]);
  const [notes, setNotes] = useState('');
  const file = useMutation({
    mutationFn: async () => (await api.post(`/orders/${orderId}/complaint`, { category, notes })).data,
    onSuccess: () => { toast.success('Complaint filed - Souqli will review it.'); onClose(); },
    onError: (e: any) => toast.error(e?.response?.data?.message ?? 'Could not file the complaint.'),
  });

  return (
    <div className="fixed inset-0 z-50 grid place-items-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose}>
      <div className="card p-6 max-w-md w-full" onClick={(e) => e.stopPropagation()}>
        <div className="stamp text-clay-dark">Report the {against}</div>
        <h2 className="display text-2xl mt-1">File a complaint</h2>
        <p className="text-sm text-mute mt-2">This goes to the Souqli team for review. It doesn't move any funds - for item/refund issues use “Report a problem” instead.</p>
        <label className="label mt-4">Reason</label>
        <select className="input" value={category} onChange={(e) => setCategory(e.target.value)}>
          {CATEGORIES[against].map((c) => <option key={c}>{c}</option>)}
        </select>
        <label className="label mt-3">Details (optional)</label>
        <textarea className="input min-h-[100px]" value={notes} maxLength={2000} onChange={(e) => setNotes(e.target.value)} placeholder="What happened?" />
        <div className="flex gap-2 mt-5">
          <button onClick={onClose} className="btn btn-outline flex-1">Cancel</button>
          <button onClick={() => file.mutate()} disabled={file.isPending} className="btn btn-primary flex-1">{file.isPending ? 'Filing…' : 'File complaint'}</button>
        </div>
      </div>
    </div>
  );
}
